import { Injectable } from '@angular/core';

@Injectable()
export class RememberScrollPosition {
  private _scrollPositions: { [key: string]: number } = {};

  public savePosition(position: number, uuid: string) {
    this._scrollPositions[uuid] = position;
  }

  public scrollPositions(uuid: string): number {
    return this._scrollPositions[uuid];
  }
}
